(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ease = (t) => 1 - Math.pow(1 - t, 3);

  const count = (el) => {
    const target = parseFloat(el.dataset.countTo);
    if (!Number.isFinite(target)) return;
    if (reduce) { el.textContent = String(target); return; }
    const dur = 1400 + Math.min(target, 60) * 8;
    const start = performance.now();
    const step = (now) => {
      const p = Math.min(1, (now - start) / dur);
      el.textContent = String(Math.round(target * ease(p)));
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = String(target);
    };
    requestAnimationFrame(step);
  };

  const init = (section) => {
    if (section.dataset.statsReady === 'true') return;
    section.dataset.statsReady = 'true';
    const nums = section.querySelectorAll('[data-count-to]');
    if (!('IntersectionObserver' in window)) { nums.forEach(count); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        e.target.querySelectorAll('[data-count-to]').forEach(count);
      });
    }, { threshold: 0.35 });
    section.querySelectorAll('.spot-stats__item').forEach((item) => io.observe(item));
  };

  const boot = () => document.querySelectorAll('[data-spot-stats]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
